<template>
  <div class="rich-text">
    <span v-for="(item, index) in richText">
      <span v-if="typeof item.insert == 'string'" v-html="item.insert"></span>
      <span
        v-else-if="typeof item.insert == 'object'"
        @click.stop="bindClickTag(item)"
        :style="{ color: '#' + item.insert['styled-mention'].color.slice(2) }"
      >
        <span>{{ item.insert['styled-mention'].specialChar }}</span>
        <span>{{ item.insert['styled-mention'].text }}</span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: String,
      default: '[]'
    }
  },
  data() {
    return {}
  },
  computed: {
    richText() {
      return JSON.parse(this.data || '[]')
    }
  },
  created() {
    setTimeout(() => {
      console.log(this.richText)
    }, 200)
  },
  methods: {
    bindClickTag(item) {
      switch (item.insert['styled-mention'].type) {
        case 'topic':
          this.jumpTopic(
            item.insert['styled-mention'].id,
            item.insert['styled-mention'].text
          )
          break
        case 'coach':
          this.jumpCoach(item.insert['styled-mention'].id)
          break
      }
    },
    jumpTopic(id, text) {
      let url = `/ugcTopicUgcListPage?topicId=${id}&topicName=${encodeURIComponent(
        text
      )}`
      this.$betterwe.jumpRoute(url)
    },
    jumpCoach(id) {
      let url = `/gymCoachDetails?id=${id}`
      this.$betterwe.jumpRoute(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.rich-text {
  font-size: 15px;
  line-height: 22px;
  color: #050b27;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
</style>
